import API_BASE_URL from '../config';

const LEGACY_HOSTS = [
    'http://localhost:4000',
    'https://localhost:4000',
    'http://127.0.0.1:4000',
    'https://127.0.0.1:4000',
];

function getBrowserOrigin() {
    try {
        if (typeof window !== 'undefined' && window.location && window.location.origin) return window.location.origin;
    } catch (_) {
        // ignore
    }
    return '';
}

function isLocalOrigin(origin) {
    if (!origin) return false;
    return /^https?:\/\/(localhost|127\.0\.0\.1)(:\d+)?$/i.test(origin);
}

export function resolveAssetUrl(input) {
    if (!input) return '';
    const url = String(input).trim();
    if (!url) return '';

    // Always use the browser's current origin so the URL works on localhost,
    // in Docker (any domain), and in production without hardcoding a hostname.
    // Nginx proxies /uploads/ to the backend in all environments.
    const browserOrigin = getBrowserOrigin();

    // If it already has any scheme (http, https, data, blob, etc), keep it untouched
    // EXCEPT for legacy localhost:4000 direct-backend URLs stored in old data — rewrite those.
    const hasScheme = /^[a-z][a-z0-9+.-]*:/i.test(url);

    if (hasScheme) {
        // Rewrite legacy absolute URLs pointing at the direct backend port (e.g. http://localhost:4000/uploads/...)
        for (const legacy of LEGACY_HOSTS) {
            if (url.startsWith(legacy)) {
                return browserOrigin ? browserOrigin + url.slice(legacy.length) : url;
            }
        }
        // Any other absolute URL (external CDN, https://...) → keep as-is
        return url;
    }

    // Relative path starting with '/' (e.g. /uploads/filename.jpg) → prepend origin
    if (url.startsWith('/')) return browserOrigin ? browserOrigin + url : url;

    // Bare relative path → prepend origin with separator
    return browserOrigin ? `${browserOrigin}/${url}` : url;
}

export function apiUrl(path) {
    const base = String(API_BASE_URL || '').replace(/\/+$/, '');
    const p = String(path || '').replace(/^\/+/, '');
    if (!base) return '/' + p;
    return `${base}/${p}`;
}

export function rewriteLegacyLocalhostInHtml(html) {
    if (!html) return html;

    const origin = getBrowserOrigin();
    const isLocal = isLocalOrigin(origin);

    // Only rewrite legacy localhost values when running locally.
    if (!isLocal || !origin) return html;

    let out = String(html);
    for (const legacy of LEGACY_HOSTS) {
        out = out.split(legacy).join(origin);
    }
    return out;
}
